import React from "react";

const BrandMixSubtitle: React.FC = () => {
    return (
        <>
            Find out what kinds of retailers are trading nearby
            and how they position their brands to attract customers.
            Dash groups them by brand tier so you can see how the area
            is positioned and where your store could fit in or stand out.
        </>
    );
};

export default BrandMixSubtitle;
